__turbopack_context__.v({
  "buttonLink": "progressive-learn-more-link-module-scss-module__jOQBQW__buttonLink",
});
